export const GET_ACTIVE_RS = "/api/active_review_schedulers";
export const GET_ACTIVE_FS = "/api/active_fs_schedulers";
export const BFILE_API_URL = "api/b_file_v2";
export const SCHEDULER_DAILY_AGENCY_TOGGLE_ASSIGNMENT = "api/scheduler_daily_agency"
export const WEEKLY_DASH_SCHEDULER_DAY_PRIORITY =
  "/api/weekly_dash_scheduler_day_priority";
export const GET_MY_ASSOCIATIONS = '/api/my_associations';
export const CHECK_IF_AGENCY_IS_ACTIVE = (agencyId) => `/api/check_if_agency_active/${agencyId}`;
export const FS_DIALS_MADE_GRID = '/api/fs_dials_made_grids';
export const RS_DIALS_MADE_GRID = '/api/rs_dials_made_grids';
export const RS_APPOINTMENT_REPORT = "/api/review_scheduler_appointment_report";
export const RS_WEEKLY_DASHBOARD = "/api/review_weekly_dashboard";
export const FS_APPOINTMENT_REPORT = "/api/fs_scheduler_appointment_report";
export const FS_WEEKLY_DASHBOARD = "/api/fs_weekly_dashboard";
export const WEEKLY_DASH_SCHEDULER_BOARD_GRID =
  "/api/weekly_dash_scheduler_board_grid";
export const WEEKLY_DASH_SCHEDULER_BOARD_STATS =
  "/api/weekly_dash_scheduler_board_stats";
export const WEEKLY_DASH_SCHEDULER_WEEK_VIEW =
  "/api/weekly_dash_scheduler_week_view";
export const WEEKLY_DASH_STAT_GRID = "/api/weekly_dash_stat_grid";
export const WEEKLY_DASH_DUE_CALLS_GRID = "/api/weekly_dash_due_calls_grid";
export const WEEKLY_DASH_ACTIVE1_GRID = "/api/weekly_dash_active1_grid";
export const WEEKLY_DASH_ACTIVE2_GRID = "/api/weekly_dash_active2_grid";
export const MY_VONBOARD_BFILE_API_URL = "api/my_vonboard_bfiles_v2";
export const ALL_ACTIVE_AGENCIES_API_URL = "/api/v2.0/all_active_agencies";
export const OLD_BFILE_API_URL = "api/b_file";
export const GLOBAL_SEARCH_API_URL = "api/global_search";
export const RESET_BFILE_API_URL = (bfileId) => `/api/reset_bfile/${bfileId}`;
export const ADD_EMAIL_TEMPLATE = '/api/email-templates'
export const GET_EMAIL_TEMPLATE = '/api/get_all_email_templates';
export const DELETE_EMAIL_TEMPLATE = (templateId) => `/api/delete_email_template/${templateId}`;
export const FIVE_NINE_REPORT = (start_date, end_date) => `/api/five9_report/${start_date}/${end_date}`;

export const IS_USER_EXIST = "/api/v3/is_user_exist";

export const DOWNLOAD_BAD_PHONE_NUMBER_REPORT = "/api/download_bad_phone_number_report";

export const GET_RFS_ALL_AGENCIES = "/api/rfs_all_agencies";
export const GET_FS_ALL_AGENCIES = "/api/fs_all_agencies";
export const RS_ALL_AGENCIES_API_URL = "/api/v2.0/rs_all_agencies";
export const GET_AGENCY_DATA_BY_ID = (agencyId) => `/api/agencies/${agencyId}`;

export const UPDATE_FS_AGENCY_ASSOC = (
  userId,
  agencyId,
  checked,
  lead,
  opportunity
) =>
  `/api/update_fs_agency_assoc/${userId}/${agencyId}/${checked}/${lead}/${opportunity}`;

export const UPDATE_RFS_AGENCY_ASSOC = (
  userId,
  agencyId,
  checked,
  lead,
  opportunity,
  review
) =>
  `/api/update_rfs_agency_assoc/${userId}/${agencyId}/${checked}/${lead}/${opportunity}/${review}`;

export const RS_AGENCIES_ASSOC = (userId) => `/api/rs_agencies_assoc/${userId}`;
export const FS_AGENCIES_ASSOC = (userId) => `/api/fs_agencies_assoc/${userId}`;
export const RFS_AGENCIES_ASSOC = (userId) =>
  `/api/rfs_agencies_assoc/${userId}`;
export function GET_RFS_USERS_AND_AGENCIES_BY_ROLES(
  userId,
  review,
  followUp,
  prospect
) {
  return `/api/users_and_agencies_by_roles?user_id=${userId}&review=${review}&followup=${followUp}&prospect=${prospect}`;
}
export const TRANSFER_RFS_BFILES = (review, opportunity, lead, role_filter) =>
  `/api/rfs_transfer_bfiles?review=${review}&lead=${lead}&opportunity=${opportunity}&role_filter=${role_filter}`;

export const DELETE_AGENCY = (agencyId) => `/api/format_agency/${agencyId}`;
export const EXTERNAL_RAC_EXISTING_CUSTOMER_CHECK =
  "/api/check_customer_exist/external_rac";
export const CUSTOMER_UPLOAD_LIVE_STAT_MONTHLY =
  "/api/v4.0/customer_upload_live_stats?&monthly_count=true";
export const CUSTOMER_UPLOAD_LIVE_STAT_TOTAL =
  "/api/v4.0/customer_upload_live_stats";
export const UPDATE_RS_EFFECTIVE_DATE = (bfileId) =>
  `/api/v1/bfiles/${bfileId}/rs_effective_date`;
export const UPDATE_ACTIVE_REVIEW_MONTH = (bfileId) =>
  `/api/update_active_review_month/${bfileId}`;
export const UPDATE_ACTIVE_FOLLOW_UP_MONTH = (bfileId) =>
  `/api/update_active_fs_month/${bfileId}`;
export const UPDATE_RAC_DATE = (bfileId) => `/api/update_rac_dates/${bfileId}`;
export const GET_PREVIOUS_CALL_ATTEMPTS_COUNT = (bfileId) =>
  `/api/retrieve_previous_attempts/${bfileId}`;
export const UPDATE_CALL_BACK_REQUEST_REVIEW = (bfileId, review_month) =>
  `/api/call_back_request_review/${bfileId}/${review_month}`;
export const MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V1 =
  "/api/v1/move_bfiles_to_review_or_follow_up";
export const MOVE_BFILES_TO_REVIEW_OR_FOLLOW_UP_V2 =
  "/api/v2/move_bfiles_to_review_or_follow_up";
export const GET_REVIEW_ACTIVE_MONTH_DROP_DOWN_STATUS = (
  type_of_call,
  bfileId
) => `/api/get_review_active_month_drop_down_status/${type_of_call}/${bfileId}`;
export const GET_ALL_USER_FOR_BAD_PHONE_NUMBER_NOTIFICATION =
  "/api/get_all_user_for_bad_phone_number_notification";
export const CREATE_NOTIFICATION = "/api/create_notification";
export const CREATE_NOTES = "/api/bfile_notes";
//search api
export const BFILE_SEARCH_API = "/api/v2.2/search_bfile_m/";
//  Manage Scheduler APIS
// invited Scheduler load users
export const INVITED_LOAD_USERS_API_URL =
  "/api/invited_scheduler_specialist_users";
// inactive Scheduler  load users
export const INACTIVE_LOAD_USERS_API_URL =
  "/api/inactive_scheduler_specialist_users";
// manage scheduler load users
export const MANAGE_SCHEDULER_LOAD_USERS_API_URL =
  "/api/manage_scheduler_specialist_users";
// invite Scheduler
export const UPDATE_USER_TOKEN = "/api/update_user_token/";
export const DELETE_EA_USER_PROFILE_PIC = "/api/delete_ea_profile_pic";
export const DELETE_LSP_USER_DP_URL = "/api/delete_lsp_dp_url";
export const GET_FS_DASHBOARD_CALLS_V2 = "api/v2/followup_specialist_dashboard";
export const GET_FS_DASHBOARD_CALLS_V5 = "api/v5/followup_specialist_dashboard";
export const GET_FS_DASHBOARD_NON_RESPONSIVE_NOT_INTERESTED =
  "/api/v2/fs_dashboard/non_responsive_not_interested";
export const GET_RS_USER_AGENCIES = "/api/rs_user_agencies";
export const SET_EXT_USER_NOTIFICATIONS = "/api/set_ext_user_for_notifications";
export const GET_AGENCY_ID = "api/v2.0/get_agency_id";
export const GET_USER_DETAILS = "/api/v2.0/get_user_details";
export const ADD_ROLES_API = "/api/add_multiple_roles_to_user";
export const GET_ROLES_API = "/api/fetch_roles";
export const GET_ROLES_BY_USER_ID_API = "/api/get_roles_by_user";
export const REMOVE_ROLES_API = "/api/remove_multiple_roles_from_user";
export const IS_USER_EXISTS_API = "/api/v2.0/is_user_exist";
export const GET_RS_REQUESTED_RESCHEDULED =
  "/api/rs_user_grid_requested_reschedules";
export const GET_RS_APPOINTMENTS_SCHEDULED =
  "/api/rs_user_grid_appointments_scheduled";
export const GET_FS_REQUESTED_RESCHEDULED =
  "/api/v2/followup_specialist_request_to_be_rescheduled";
export const GET_RS_DUE_CALLS = "/api/rs_user_grid_due_calls";
export const GET_FS_DUE_CALLS = "/api/v2/followup_specialist_due_calls";
export const GET_FS_UPCOMING_CALLS =
  "/api/v2/followup_specialist_upcomming_calls";
export const GET_RS_ACTIVE_CALLS = "/api/rs_user_grid_active_calls";
export const GET_RS_NON_RESPONSIVE = "/api/rs_user_grid_non_responsive";
export const GET_FS_NOT_INTERESTED =
  "/api/v2/followup_specialist_not_interested";
export const GET_FS_ACTIVE_CALLS = "/api/v2/followup_specialist_active_call";
export const GET_FS_NON_RESPONSIVE =
  "/api/v2/followup_specialist_non_responsive";
export const GET_RS_NOT_INTERESTED = "/api/rs_user_not_interested_calls";
export const GET_RS_BAD_PHONE_NUMBERS = "/api/rs_use_grid_bad_phone_numbers";
export const GET_FS_APPOINTMENT_SCHEDULED =
  "/api/v2/followup_specialist_appointment_scheduled";
export const GET_RS_UPCOMING_CALLS = "/api/rs_user_grid_upcoming_calls";
export const GET_FS_BAD_PHONE_NUMBERS =
  "/api/v2/followup_specialist_bad_phone_number";
export const GET_RS_CALL_STATITICS = "/api/rs_admin_dashboard_call_stats";
export const GET_RS_APPOINTMENT_STATS =
  "/api/rs_admin_dashboard_appointment_stats";
export const GET_RS_OTHER_STATISTICS_PIE =
  "/api/rs_admin_dashboard_sub_type_call_stats";
export const GET_RS_LEADERBOARD = "/api/rs_admin_user_with_appointments";
export const GET_RS_OTHER_STATISTICS_PIE_1 =
  "/api/rs_admin_dashboard_call_action_stats";
export const GET_RS_ADMIN_AGENCYS = "/api/rs_admin_agencies";
export const GET_FS_ADMIN_AGENCYS = "/api/fs_admin_agencies";

export const GET_RS_AGENT_LISTING = "/api/agency_associations_appointments";
export const GET_AGENT_LISTING = "/api/agency_associations/";
export const GET_RS_USER_ID_AGENCIES_ASSOCIATED = "/api/v2.0/rs_user_agencies/";

//RS_Admin User Stats
export const GET_RS_ADMIN_USER_STATS = "/api/rs_admin_user_stats";
export const GET_RS_ADMIN_CALL_DATA = "/api/rs_admin_user_grids";
export const GET_FS_CLAIMED_CALLS = "/api/v2/followup_specialist_claimed_call";

//FS Admin Grid API
export const GET_FS_ADMIN_GRID_DATA = "/api/fs_admin_user_grids";

export const GET_AM_ASSOCIATED_AGENCIES = "/api/am_agencies_assoc";
export const GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE = "/api/global_dashboard/all_agencies";
export const GET_GLOBAL_DASH_BAD_PHONE_NUMBER_COUNT = "/api/global_dash_bad_phone_number_count";
export const GET_GLOBAL_DASH_ACTIVE_CALLS_COUNT = "/api/global_dash_active_calls_count";
export const GET_GLOBAL_DASH_STATS = "/api/global_dash_stats";
export const GET_GLOBAL_DASH_THREE_CARD_STATS = "/api/global_dash/three_card_stats";
export const GET_GLOBAL_DASH_CUSTOMER_UPLOAD_LIVE_STATS = "/api/global_dash/customer_upload_live_stats";
export const GET_GLOBAL_DASH_LIVE_APPOINTMENTS = "/api/global_dash/get_live_appointments";
export const GET_GLOBAL_DASH_BAD_PHONE_NUMBER_GRID = "/api/global_dash_bad_phone_number_grid";
export const GET_GLOBAL_DASH_COMPLETED_GRID = "/api/global_dash_completed_grid";
export const GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_GRID = "/api/global_dash/external_rac_bfile_grids";
export const GET_GLOBAL_DASH_POLICIES_UNCOVERED_GRID = "/api/global_dash_policies_uncovered_grid";
export const GET_GLOBAL_DASH_UMBRELLA_UNCOVERED_GRID = "/api/global_dash_umbrella_uncovered_grid";
export const GET_GLOBAL_DASH_LIFE_OPPORTUNITIES_GRID = "/api/global_dash_life_opportunities_grid";
export const GET_GLOBAL_DASH_ASSETS_UNCOVERED_GRID = "/api/global_dash_assets_uncovered_grid";
export const GET_GLOBAL_DASH_RETIREMENT_UNCOVERED_GRID = "/api/global_dash_retirement_uncovered_grid";
export const GET_GLOBAL_DASH_ACTIVE_CALLS_GRID = "/api/global_dash_active_calls_grid";
export const GET_GLOBAL_DASH_CUSTOMER_UPLOADED_GRID = "/api/global_dash_customer_uploaded_grid";
export const GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_GRID = "/api/global_dash_scheduled_activities_grid";
export const GET_GLOBAL_DASH_NON_RESPONSIVE_GRID = "/api/global_dash_non_responsive_grid";
export const GET_GLOBAL_DASH_NOT_INTERESTED_GRID = "/api/global_dash_not_interested_grid";
export const GET_AM_DASHBOARD_STATS = "/api/dash_stats_am";
export const GET_AM_DASH_BAD_PHONE_NUMBER_COUNT =
  "/api/agency_manager_bad_phone_number_count";
export const GET_AM_DASH_GET_COMPLETED_HISTORY_COUNT =
  "/api/agency_manager_completed_history";
export const GET_AM_DASH_THREE_CARDS_STAT =
  "api/agency_manager_dashboard_history";
export const GET_AM_DASH_ACTIVE_CALL_COUNT =
  "api/agency_manager_active_call_count";

export const GET_ALL_BFILES = "/api/v2/all_bfiles";
export const GET_ALL_DELETED_BFILES = "/api/v2/all_deleted_bfiles";

export const GET_AM_DASH_SCHEDULED_ACTIVITIES_GRID =
  "/api/am_scheduled_activities_grid";
export const GET_AM_DASH_CUSTOMER_UPLOADED_GRID =
  "/api/am_customer_uploaded_grid";
export const GET_AM_DASH_NON_RESPONSIVE_GRID = "/api/am_non_responsive_grid";
export const GET_AM_DASH_NOT_INTERESTED_GRID = "/api/am_not_interested_grid";
export const GET_AM_DASH_ACTIVE_CALLS_GRID = "/api/am_active_calls_grid";
export const GET_AM_DASH_TOTAL_CUSTOMER_UPLOADED_GRID =
  "/api/am_total_customer_uploaded_grid";
export const GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID =
  "/api/ao_am_as/external_rac_bfile_grids";
export const GET_AM_AO_AS_EXTERNAL_RAC_LIVE_GRID =
  "/api/ao_am_as_live/external_rac_bfile_grids";
export const COMBINED_COMPLETED_RAC_COUNT =
  "/api/v4.0/combined_completed_external_rac_count";
export const COMBINED_COMPLETED_RAC_GRID =
  "/api/v4.0/combined_completed_external_rac_grid";
export const GET_AM_DASH_FOLLOWUP_GRID = "/api/am_followup_grid";
export const GET_AM_DASH_SAVE_FOR_LATER_GRID = "/api/am_save_for_later_grid";
export const GET_AM_DASH_POLICIES_UNCOVERED_GRID =
  "/api/am_policies_uncovered_grid";
export const GET_AM_DASH_RETIREMENT_UNCOVERED_GRID =
  "/api/am_retirement_uncovered_grid";
export const GET_AM_DASH_LIFE_OPPORTUNITIES_GRID =
  "/api/am_life_opportunities_grid";
export const GET_AM_DASH_ASSETS_UNCOVERED_GRID =
  "/api/am_assets_uncovered_grid";
export const GET_AM_DASH_COMPLETED_GRID = "/api/am_completed_grid";
export const GET_AM_UMBRELLA_UNCOVERED_GRID = "api/am_umbrella_uncovered_grid";

export const EXTERNAL_RAC_UPLOAD_HISTORY = "/api/upload_history/external_rac";

export const GET_AM_DASH_REVIEW_APPOINTMENT_BTN_CLICK =
  "/api/am_review_appointments_scheduled_grid";
export const GET_AM_DASH_LEAD_APPOINTMENT_BTN_CLICK =
  "/api/am_lead_appointments_scheduled_grid";
export const GET_AM_DASH_OPPORTUNIY_BTN_CLICK =
  "/api/am_opportunity_appointments_scheduled_grid";
export const GET_GLOBAL_DASH_REVIEW_APPOINTMENTS_SCHEDULED_GRID =
  "/api/global_dash_review_appointments_scheduled_grid";
export const GET_GLOBAL_DASH_LEAD_APPOINTMENTS_SCHEDULED_GRID =
  "/api/global_dash_lead_appointments_scheduled_grid";
export const GET_GLOBAL_DASH_OPPORTUNITY_APPOINTMENTS_SCHEDULED_GRID =
  "/api/global_dash_opportunity_appointments_scheduled_grid";

export const GET_AM_DASH_CUSTOMER_UPLOADED_HISTORY_GRID =
  "/api/am_history_customer_uploaded_grid";
export const GET_AM_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID =
  "/api/am_history_scheduled_activities_grid";
export const GET_AM_DASH_NOT_INTERESTED_HISTORY_GRID =
  "/api/am_history_not_interested_grid";
export const GET_AM_DASH_COMPLETED_HISTORY_GRID =
  "/api/am_history_completed_grid";

export const GET_AO_DASH_CUSTOMER_UPLOADED_HISTORY_GRID =
  "/api/ao_history_customer_uploaded_grid";
export const GET_AO_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID =
  "/api/ao_history_scheduled_activities_grid";
export const GET_AO_DASH_NOT_INTERESTED_HISTORY_GRID =
  "/api/ao_history_not_interested_grid";
export const GET_AO_DASH_COMPLETED_HISTORY_GRID =
  "/api/ao_history_completed_grid";
export const GET_GLOBAL_DASH_COMPLETED_HISTORY_GRID =
  "/api/global_dash_history_completed_grid";
export const GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_HISTORY_GRID =
  "/api/global_dash/external_rac_bfile_history_grids";
export const GET_GLOBAL_DASH_CUSTOMER_UPLOADED_HISTORY_GRID =
  "/api/global_dash_history_customer_uploaded_grid";
export const GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID =
  "/api/global_dash_history_scheduled_activities_grid";
export const GET_GLOBAL_DASH_NOT_INTERESTED_HISTORY_GRID =
  "/api/global_dash_history_not_interested_grid";

export const GET_AM_DASH_BAD_PHONE_NUMBER_GRID =
  "/api/am_bad_phone_number_grid";

export const GET_VONBOARD_DROPDOWN_USERS_LIST =
  "/api/v3.0/vonoboard_users_list";
export const GET_REVIEWADMIN_DROPDOWN_USERS_LIST = "/api/rs_admin_users";
export const GET_FS_CALL_ACTION_STATS =
  "/api/fs_admin_dashboard_call_action_stats";
export const GET_SUB_TYPE_OF_CALL_STATS =
  "/api/fs_admin_dashboard_sub_type_call_stats";
export const GET_TYPE_OF_CALL_STATS = "/api/fs_admin_dashboard_type_call_stats";
export const GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS =
  "/api/fs_admin_dashboard_appointment_stats";
export const GET_FS_LEADERBOARD = "/api/fs_admin_user_with_appointments";
export const GET_FS_ADMIN_CALL_STATISTICS =
  "/api/fs_admin_dashboard_call_stats";
export const GET_FS_ADMIN_USER_STATS = "/api/fs_admin_user_stats";
export const GET_FS_ADMIN_QUEUED_BFILES = "/api/fs_admin_queued_data_grids";
export const GET_RS_ADMIN_QUEUED_BFILES = "/api/rs_admin_queued";

//historic grid count
export const GET_NOT_INTERESTED_HISORICAL_DATA =
  "/api/v2.0/not_interested/history/details";
export const GET_APPOINTMENT_HISTORY_HISTORICAL_DATA =
  "/api/v2.0/appointments_history/details";
export const GET_CALL_ATTEMPS_HISTORY_DETAILS =
  "/api/v2.0/call_attempts_history/details";
export const GET_CALL_BACK_HISTORY_DETAILS =
  "/api/v2.0/call_back_request_history/details";
export const GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY =
  "/api/v2/appointments_history/subtype_of_call";
export const GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID =
  "/api/rs_admin/external_rac_bfile_grids";
export const GET_RS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES =
  "/api/rs_admin/external_rac_bfile_grids_inactive_agencies";
export const GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID_INACTIVE_AGENCIES =
  "/api/fs_admin/external_rac_bfile_grids_inactive_agencies";

export const GET_FS_ADMIN_EXTERNALLY_COMPLETED_BFILE_GRID =
  "/api/fs_admin/external_rac_bfile_grids";

export const GET_USER_EMAIL_NOTIFICATIONS = (notificationType) =>
  `api/get_user_email_notifications?type=${notificationType}`;
export const SET_USER_EMAIL_NOTIFICATIONS = "/api/set_user_email_notifications";

// check before deactivating
export const CHECK_BEFORE_DEACTIVATE_API =
  "/api/v2.0/scheduler_status_before_deactivating";
export const GET_RS_USERS_API = "/api/v2.0/rs_users";
export const TRANSFER_BFILES_API = "/api/v2/vo_transfer_bfiles";

// REVIEW:Review
export const API_CHECK_BEFORE_REMOVE_ROLE_REVIEW_API =
  "/api/v2.0/check_before/unclick_review";
// Opportunity :FollowUp
export const API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API =
  "/api/v2.0/check_before/unclick_vonboard";
// Lead:Prospect
export const API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API = "/api/v2.0/check_before/unclick_vonboard";

// Transfer B-Files API url 
export const TRANSFER__BFILES_API_V3 = "api/v3/vo_transfer_bfiles?user_type=BOBADMIN"
export const TRANSFER__BFILES_API_V4 = "/api/v4/vo_transfer_bfiles?user_type=SUPER_ADMIN";
export const GET_EXTERNAL_RAC_RECENT_FILES_COUNT = (userId) => `/api/ao_am/external_rac_recent_files_count?user_id=${userId}`;
export const POST_ACKNOWLEDGE_EXT_RAC_FILE = (userId) => `/api/ao_am/acknowldege/external_rac_recent_files?user_id=${userId}`

// all BFiles API urls
export const VONBOARDER_AGENCIES_API_URL = "/api/vonboarder_lead_opp_agencies";
export const RS_DEDICATED_AGENCIES_API_URL = "/api/rs_agencies_assoc";
export const RS_DEDICATED_AGENCIES_API_URL_V2 = "/api/v2.0/rs_agencies_assoc"; // using now for listing in drop down
export const AGENT_SEARCH_API_URL = "/api/ea_lsp_users";

export const NEW_BFILES_FS_RS_API_URL = "/api/b_file_fs_rs";

// agencies uncheck
export const AGENCY_UNCLICK_REVIEW_API_URL =
  "/api/v2.0/check_before/unclick_review/unclick_agency";

//EA/staff Dashboard
export const GET_LIVE_APPOINTMENT = "/api/v4.0/get_live_appointments";
export const GET_BAD_PHONE_NUMBER_COUNT = "/api/v3.0/count_bad_phone_number";
export const GET_THREE_CARD_DATA = "/api/v4.0/three_card_stats";
export const GET_EA_ACTIVE_CALLS = "/api/v3.0/count_active_calls";
export const GET_EA_AGENCY_STATS = "/api/dash_stats_agency_stats";
export const GET_EA_STATS = "/api/dash_stats_stats";
export const GET_LSP_STATS = "/api/dash_stats_lsp_stats";

export const SWITCH_USER_ROLE_API_URL = "/api/v2.0/switchuser/";
export const VONBOARDERS_USERS_LIST_API_URL = "/api/v3.0/vonoboard_users_list";

//Customer profile api's
export const CREATE_CALL_ATTEMPT_HISTORY = "/api/call_attempts_history";

//CallBack history
export const CREATE_CALL_BACK_HISTORY = "/api/call_back_request_history";

export const DOWNLOAD_REPORT_API_URL = "/api/download_report";
//request call
export const REQUEST_CALL = "/api/request_call";
//schedule Appointment
export const SCHEDULE_APPOINTMENT = "/api/schedule_appointment";
//Not reached
export const NOT_REACHED = "/api/not_reached/update";
//Not Interested
export const NOT_INTERESTED = "/api/not_interested/update";
//Non Responsive
export const NON_RESPONSIVE = "/api/non_responsive/update";

//deactivate user
export const DEACTIVATE_USER = "/api/click/user/inactiive/";

export const ADMIN_DASHBORAD_RS_CHART_GRID_API =
  "/api/rs_admin_dashboard_chart_grid?";
// inactive-agencies
export const INACTIVE_AGENCIES_API_URL = "/api/superadmin/inactive/agencies";

// active-Agencies
export const ACTIVE_AGENCIES_API_URL = "/api/superadmin/active/agencies";

// locked-user
export const LOCKED_USERS_API_URL = "/api/locked_users";

// manage-user AM
export const AGENCY_MANAGERS_API_URL = "/api/manage_users/agency_managers";



// WEBPACK FOOTER //
// ./src/utils/Api_enums.js